import { render, staticRenderFns } from "./WaiverFormPRPAdmin.vue?vue&type=template&id=85ce56c2&scoped=true&"
import script from "./WaiverFormPRPAdmin.vue?vue&type=script&lang=js&"
export * from "./WaiverFormPRPAdmin.vue?vue&type=script&lang=js&"
import style0 from "./WaiverFormPRPAdmin.vue?vue&type=style&index=0&id=85ce56c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ce56c2",
  null
  
)

export default component.exports